var EE = require('events').EventEmitter

var sin = Math.sin.bind(Math)
  , H_PI = Math.PI / 2

module.exports = ease
ease.Easing = Easing

function Easing(target, initial, _timeout, _now) {
  if(!(this instanceof Easing)) {
    return new Easing(target, initial, _timeout, _now)
  }

  this.timeout = _timeout || this.timeout
  this.now = _now || this.now
  this.initial = initial || 0
  this.target = target
  this.elapsed = 0
  this.duration = 1000
}

var cons = Easing
  , proto = cons.prototype

proto.ease = function() {
  var diff = (this.target - this.initial)

  diff *= sin(this.elapsed / this.duration * H_PI)

  return this.initial + diff
}

proto.now = function() {
  return Date.now()
}

proto.timeout = function() {
  return setTimeout.apply(null, arguments)
}

proto.start = function(duration) {
  var self = this

  self.duration = duration || self.duration

  var now = self.now()
    , ee = new EE
    , tmp
    , dt

  self.timeout(iter, 0)

  return ee

  function iter() {
    tmp = self.now()
    dt = tmp - now
    now = tmp
    self.elapsed += dt

    if(self.elapsed >= self.duration) {
      ee.emit('data', self.target)
      ee.emit('end', self.target)
      ee.removeAllListeners('data')
      ee.removeAllListeners('end')
    } else {
      ee.emit('data', self.ease())
      self.timeout(iter, 0)
    }
  }
}

function ease(from, to, duration) {
  var easing = new Easing(to, from)

  return easing.start(duration)
}
